import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import { CloseIcon } from "asset/icons";
import { useMutation } from "react-query";
import { handleCancelShipment } from "api/fetchers";
import Swal from "sweetalert2";
import Loader from "component/loader";
import { toast } from "react-toastify";

const CancelShipmentModal = ({ show, onClose, shipmentDetails, refetchData }) => {
    const [trackingNumber, setTrackingNumber] = useState("");
    const [note, setNote] = useState("");

    const { generatedTitle } = shipmentDetails ?? {};
    const expectedTrackingNumber = generatedTitle?.split("-")?.at(-1);

    const canCancelShipment = expectedTrackingNumber === trackingNumber;

    const handleCloseFunc = () => {
        onClose();
        setTrackingNumber("");
        setNote("");
    };

    const { mutateAsync: cancelShipmentFunc, isLoading } = useMutation({
        mutationFn: () => handleCancelShipment(shipmentDetails?._id),
        mutationKey: [shipmentDetails?._id],
        onSuccess: (data) => {
            if (data?.message) {
                toast.success(data?.message || "Cancelled succefully");
            } else {
                toast.error(data?.response?.data?.message || "Something went wrong");
            }
            refetchData?.();
        },
    });

    return (
        <Modal
            show={show}
            contentClassName="!rounded-xl w-full border-0 mx-auto"
            size="xl"
            centered
        >
            <div className="flex items-center justify-between p-4">
                <div>
                    <h3 className="mb-0 text-2xl font-semibold text-main-dark">Cancel Shipment</h3>
                    <p className="text-sm font-light text-gray-50">
                        Enter the tracking number to cancel the shipment
                    </p>
                </div>
                <CloseIcon
                    onClick={handleCloseFunc}
                    className="w-6 h-6 text-gray-500 cursor-pointer hover:text-gray-800"
                />
            </div>

            <form className="">
                <div className="flex flex-col gap-2 p-4 pt-0">
                    <label htmlFor="" className="text-[#475467] font-medium text-sm leading-5">
                        Confirm tracking number*
                    </label>
                    <div className="input_sign_code has-[:focus]:bg-[#EAECF0] bg-[#EAECF0] rounded-md">
                        <div className="flex items-center py-1">
                            <p className="pr-2 text-lg whitespace-nowrap balance_number text-gray-10">
                                TSH -
                            </p>

                            <input
                                type="number"
                                className="w-full focus:bg-[#EAECF0] !shadow-none text-gray-10"
                                placeholder="Tracking Number"
                                onChange={(e) => setTrackingNumber(e.target.value)}
                                required
                                value={trackingNumber}
                            />
                        </div>
                    </div>
                </div>

                <div className="flex flex-col gap-2 p-4 pt-0">
                    <label htmlFor="" className="text-[#475467] font-medium text-sm leading-5">
                        Why are you cancelling this shipment
                    </label>
                    <div style={{ gap: "8px" }}>
                        <textarea
                            type="text"
                            name=""
                            id=""
                            onChange={(e) => {
                                setNote(e.target.value);
                            }}
                            value={note}
                            className="customInput !h-[83px]"
                            placeholder="Enter reason here"
                        ></textarea>
                    </div>
                </div>

                <div className="flex items-center justify-end p-4 border-t border-gray-200">
                    <button
                        type="button"
                        onClick={() => {
                            if (!canCancelShipment) {
                                Swal.fire({
                                    text: "Incorrect Tracking Number",
                                    icon: "error",
                                    confirmButtonText: "Close",
                                    width: "280px",
                                    confirmButtonColor: "crimson",
                                });
                            } else {
                                cancelShipmentFunc();
                            }
                        }}
                        disabled={isLoading || !trackingNumber}
                        className={`${
                            isLoading || !trackingNumber
                                ? "!bg-[#EBE4FF] text-[#BFA6FF]"
                                : "!bg-[#6F00FF] text-[#ffff]"
                        } px-4 py-2 border-0 outline-0 rounded-[8px] flex justify-center items-center text-[16px] leading-6 tracking-[2%] font-medium`}
                    >
                        {isLoading ? <Loader /> : "Cancel shipment"}
                    </button>
                </div>
            </form>
        </Modal>
    );
};

export default CancelShipmentModal;
